import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface BillingEntity {
    id: number;
    name: string;
    legal_name: string;
    rfc: string;
    regimen_fiscal_key: string;
    postal_code: string;
    serie: string | null;
    is_active: boolean;
    street?: string | null;
    exterior_number?: string | null;
    cologne?: string | null;
    locality?: string | null;
    municipality?: string | null;
    state?: string | null;
    country?: string | null;
    issuer_csd_serial?: string | null;
}

@Injectable({ providedIn: 'root' })
export class BillingEntityService {
    private api_url = environment.url;

    constructor(private http: HttpClient) {}

    list() {
        return this.http.get<BillingEntity[]>(`${this.api_url}billing-entity/list`);
    }

    show(id: number) {
        return this.http.get<BillingEntity>(`${this.api_url}billing-entity/show/${id}`);
    }

    create(payload: Partial<BillingEntity>) {
        return this.http.post<BillingEntity>(`${this.api_url}billing-entity/create`, payload);
    }

    update(id: number, payload: Partial<BillingEntity>) {
        return this.http.post<BillingEntity>(`${this.api_url}billing-entity/update/${id}`, payload);
    }

    delete(id: number) {
        return this.http.post<{ ok: boolean }>(`${this.api_url}billing-entity/delete/${id}`, {});
    }
}
